var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgNewBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 323.407,
    height: 140.43,
    viewBox: "0 0 323.407 140.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_5194",
    x: 161.83,
    y: 88.567,
    width: 80.906,
    height: 51.863,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_5194-2",
    x: 242.501,
    y: 47.985,
    width: 80.906,
    height: 51.863,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_5194-3",
    x: 17.501,
    y: 30.554,
    width: 80.906,
    height: 51.863,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_NewBlank",
    transform: "translate(-29.229 -4.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12677",
    "data-name": "Group 12677",
    transform: "translate(51.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12497",
    "data-name": "Group 12497",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 27.418, 21.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5169",
    "data-name": "Path 5169",
    d: "M141.345,86.689H7.67A7.678,7.678,0,0,1,0,79.019V7.67A7.678,7.678,0,0,1,7.67,0H141.345a7.678,7.678,0,0,1,7.669,7.67v71.35A7.678,7.678,0,0,1,141.345,86.689Z",
    transform: "translate(58.384 21.345)",
    fill: "#fff",
    stroke: "#f5f5f5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5170",
    "data-name": "Path 5170",
    d: "M135.767,75.533H2.092A2.094,2.094,0,0,1,0,73.441V2.092A2.094,2.094,0,0,1,2.092,0H135.767a2.094,2.094,0,0,1,2.092,2.092v71.35A2.094,2.094,0,0,1,135.767,75.533ZM2.092.465A1.629,1.629,0,0,0,.465,2.092v71.35a1.629,1.629,0,0,0,1.627,1.627H135.767a1.629,1.629,0,0,0,1.627-1.627V2.092A1.629,1.629,0,0,0,135.767.465Z",
    transform: "translate(63.962 26.923)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5171",
    "data-name": "Path 5171",
    d: "M134.917,118.3,5.7,84.051A7.678,7.678,0,0,1,.256,74.672L18.538,5.7A7.678,7.678,0,0,1,27.917.256L157.13,34.508a7.678,7.678,0,0,1,5.448,9.379L144.3,112.854A7.678,7.678,0,0,1,134.917,118.3Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5172",
    "data-name": "Path 5172",
    d: "M130.769,107.333,1.556,73.081A2.094,2.094,0,0,1,.07,70.524L18.352,1.556A2.094,2.094,0,0,1,20.91.07L150.123,34.322a2.094,2.094,0,0,1,1.486,2.558l-18.282,68.968A2.094,2.094,0,0,1,130.769,107.333ZM20.791.519A1.629,1.629,0,0,0,18.8,1.675L.519,70.643a1.629,1.629,0,0,0,1.156,1.989l129.213,34.252a1.629,1.629,0,0,0,1.989-1.156L151.159,36.76A1.629,1.629,0,0,0,150,34.771Z",
    transform: "translate(5.578 5.578)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5167",
    "data-name": "Path 5167",
    d: "M303.857,483.637H224.468c-2.514-.007-4.42-.443-4.555-3.953V365.277c-.11-3.729,2.04-3.986,4.555-3.993h79.389c2.514.007,4.188.163,4.555,3.993V479.683C308.412,482.879,306.372,483.63,303.857,483.637Z",
    transform: "translate(-141.327 -340.885)",
    fill: "#fff",
    stroke: "#434159",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18011",
    "data-name": "Rectangle 18011",
    transform: "translate(81.588 23.179)",
    fill: "#fff",
    stroke: "#ccc",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 117,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 81,
    height: 116,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12500",
    "data-name": "Group 12500",
    transform: "translate(91.023 84.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5194-4",
    "data-name": "Path 5194",
    d: "M248.688,208.826H186.617v-41.3h62.071Z",
    transform: "translate(-186.617 -167.522)",
    fill: "#f2f2f2",
    stroke: "#ffc10a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342",
    width: 43.103,
    height: 3.529,
    transform: "translate(9.484 11.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343",
    "data-name": "Rectangle 343",
    width: 43.103,
    height: 3.529,
    transform: "translate(9.484 18.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344",
    "data-name": "Rectangle 344",
    width: 43.103,
    height: 3.529,
    transform: "translate(9.484 26.771)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12501",
    "data-name": "Group 12501",
    transform: "translate(91.023 37.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5194-5",
    "data-name": "Path 5194",
    d: "M248.688,205.76H186.617V167.522h62.071Z",
    transform: "translate(-186.617 -165.828)",
    fill: "#f2f2f2",
    stroke: "#ffc10a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342-2",
    "data-name": "Rectangle 342",
    width: 43.103,
    height: 3.529,
    transform: "translate(9.484 10.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343-2",
    "data-name": "Rectangle 343",
    width: 43.103,
    height: 3.529,
    transform: "translate(9.484 18.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344-2",
    "data-name": "Rectangle 344",
    width: 43.103,
    height: 3.529,
    transform: "translate(9.484 25.798)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12499",
    "data-name": "Group 12499",
    transform: "translate(144.328 96.725)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -166.33, -92.07)",
    filter: "url(#Path_5194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_5194-6",
    "data-name": "Path 5194",
    transform: "translate(-20.29 -75.46)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 258.0230407714844 209.8851928710938 L 187.1168670654297 209.8851928710938 L 187.1168670654297 168.0218963623047 L 258.0230407714844 168.0218963623047 L 258.0230407714844 209.8851928710938 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 257.5230407714844 209.3851928710938 L 257.5230407714844 168.5218963623047 L 187.6168670654297 168.5218963623047 L 187.6168670654297 209.3851928710938 L 257.5230407714844 209.3851928710938 M 258.5230407714844 210.3851928710938 L 186.6168670654297 210.3851928710938 L 186.6168670654297 167.5218963623047 L 258.5230407714844 167.5218963623047 L 258.5230407714844 210.3851928710938 Z",
    stroke: "none",
    fill: "#e6e6e6"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342-3",
    "data-name": "Rectangle 342",
    width: 52.938,
    height: 3.529,
    transform: "translate(9.484 11.458)",
    fill: "#3f3d56",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343-3",
    "data-name": "Rectangle 343",
    width: 52.938,
    height: 3.529,
    transform: "translate(9.484 19.667)",
    fill: "#3f3d56",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344-3",
    "data-name": "Rectangle 344",
    width: 52.938,
    height: 3.529,
    transform: "translate(9.484 27.876)",
    fill: "#3f3d56",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12498",
    "data-name": "Group 12498",
    transform: "translate(225 56.144)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -247, -51.49)",
    filter: "url(#Path_5194-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_5194-7",
    "data-name": "Path 5194",
    transform: "translate(60.38 -116.04)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 258.0230407714844 209.8851928710938 L 187.1168670654297 209.8851928710938 L 187.1168670654297 168.0218963623047 L 258.0230407714844 168.0218963623047 L 258.0230407714844 209.8851928710938 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 257.5230407714844 209.3851928710938 L 257.5230407714844 168.5218963623047 L 187.6168670654297 168.5218963623047 L 187.6168670654297 209.3851928710938 L 257.5230407714844 209.3851928710938 M 258.5230407714844 210.3851928710938 L 186.6168670654297 210.3851928710938 L 186.6168670654297 167.5218963623047 L 258.5230407714844 167.5218963623047 L 258.5230407714844 210.3851928710938 Z",
    stroke: "none",
    fill: "#e6e6e6"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342-4",
    "data-name": "Rectangle 342",
    width: 52.938,
    height: 3.529,
    transform: "translate(9.484 11.458)",
    fill: "#3f3d56",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343-4",
    "data-name": "Rectangle 343",
    width: 52.938,
    height: 3.529,
    transform: "translate(9.484 19.667)",
    fill: "#3f3d56",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344-4",
    "data-name": "Rectangle 344",
    width: 52.938,
    height: 3.529,
    transform: "translate(9.484 27.876)",
    fill: "#3f3d56",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12678",
    "data-name": "Group 12678",
    transform: "translate(0 38.712)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -22, -34.05)",
    filter: "url(#Path_5194-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_5194-8",
    "data-name": "Path 5194",
    transform: "translate(-164.62 -133.47)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 258.0230407714844 209.8851928710938 L 187.1168670654297 209.8851928710938 L 187.1168670654297 168.0218963623047 L 258.0230407714844 168.0218963623047 L 258.0230407714844 209.8851928710938 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 257.5230407714844 209.3851928710938 L 257.5230407714844 168.5218963623047 L 187.6168670654297 168.5218963623047 L 187.6168670654297 209.3851928710938 L 257.5230407714844 209.3851928710938 M 258.5230407714844 210.3851928710938 L 186.6168670654297 210.3851928710938 L 186.6168670654297 167.5218963623047 L 258.5230407714844 167.5218963623047 L 258.5230407714844 210.3851928710938 Z",
    stroke: "none",
    fill: "#e6e6e6"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342-5",
    "data-name": "Rectangle 342",
    width: 44.341,
    height: 3.529,
    transform: "translate(18.081 11.458)",
    fill: "#3f3d56",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343-5",
    "data-name": "Rectangle 343",
    width: 44.341,
    height: 3.529,
    transform: "translate(18.081 19.667)",
    fill: "#3f3d56",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344-5",
    "data-name": "Rectangle 344",
    width: 44.341,
    height: 3.529,
    transform: "translate(18.081 27.876)",
    fill: "#3f3d56",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342-6",
    "data-name": "Rectangle 342",
    width: 5.252,
    height: 3.529,
    transform: "translate(9.484 11.458)",
    fill: "#3f3d56",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343-6",
    "data-name": "Rectangle 343",
    width: 5.252,
    height: 3.529,
    transform: "translate(9.484 19.667)",
    fill: "#3f3d56",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344-6",
    "data-name": "Rectangle 344",
    width: 5.252,
    height: 3.529,
    transform: "translate(9.484 27.876)",
    fill: "#3f3d56",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(103.434 61.106)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_220",
    "data-name": "Ellipse 220",
    cx: 19.402,
    cy: 19.402,
    r: 19.402,
    fill: "#1791ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M360.764,303.027h-7.75v-7.75a1.824,1.824,0,0,0-1.824-1.824h0a1.824,1.824,0,0,0-1.824,1.824v7.75h-7.75a1.824,1.824,0,0,0-1.824,1.824h0a1.824,1.824,0,0,0,1.824,1.824h7.75v7.75a1.824,1.824,0,0,0,1.824,1.824h0a1.824,1.824,0,0,0,1.824-1.824v-7.75h7.75a1.824,1.824,0,0,0,1.824-1.824h0a1.824,1.824,0,0,0-1.824-1.824h0Z",
    transform: "translate(-331.914 -285.554)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342-7",
    "data-name": "Rectangle 342",
    width: 43.103,
    height: 3.529,
    transform: "translate(91.023 29.249)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342-8",
    "data-name": "Rectangle 342",
    width: 62.071,
    height: 1.529,
    transform: "translate(91.023 34.116)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lockup",
    transform: "translate(29.229 108.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sub_and_Title",
    "data-name": "Sub and Title",
    transform: "translate(0 -262.76)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "From_Scratch",
    "data-name": "From Scratch",
    transform: "translate(0 277.76)",
    fontSize: 14,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "From Scratch")), /*#__PURE__*/React.createElement("text", {
    id: "New_form",
    "data-name": "New form",
    transform: "translate(0 273.76)",
    fill: "#7a7a7a",
    fontSize: 10,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NEW FORM")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNewBlank);
export default __webpack_public_path__ + "static/media/img_NewBlank.c7b77cfe.svg";
export { ForwardRef as ReactComponent };